import React from 'react'
import { SvgIcon } from '@material-ui/core'

function HierarchyShowIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Rectangle 142 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.07202 4.53017C9.07202 4.07178 9.44361 3.7002 9.90199 3.7002H13.8674C14.3258 3.7002 14.6974 4.07179 14.6974 4.53017V8.49558C14.6974 8.95397 14.3258 9.32555 13.8674 9.32555H9.90199C9.44361 9.32555 9.07202 8.95396 9.07202 8.49558V4.53017ZM10.317 4.94515V8.0806H13.4524V4.94515H10.317Z'
      />
      <path
        id='Rectangle 144 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4 15.4813C4 15.023 4.37159 14.6514 4.82997 14.6514H8.79539C9.25377 14.6514 9.62536 15.023 9.62536 15.4813V19.4468C9.62536 19.9051 9.25377 20.2767 8.79539 20.2767H4.82997C4.37159 20.2767 4 19.9051 4 19.4468V15.4813ZM5.24496 15.8963V19.0318H8.3804V15.8963H5.24496Z'
      />
      <path
        id='Rectangle 145 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14.3746 15.4813C14.3746 15.023 14.7462 14.6514 15.2046 14.6514H19.17C19.6284 14.6514 20 15.023 20 15.4813V19.4468C20 19.9051 19.6284 20.2767 19.17 20.2767H15.2046C14.7462 20.2767 14.3746 19.9051 14.3746 19.4468V15.4813ZM15.6196 15.8963V19.0318H18.755V15.8963H15.6196Z'
      />
      <path
        id='Vector 13 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.31991 12.7264V15.2163C7.31991 15.5601 7.04121 15.8388 6.69743 15.8388C6.35364 15.8388 6.07495 15.5601 6.07495 15.2163V12.3114C6.07495 11.853 6.44654 11.4814 6.90492 11.4814H16.8646C17.323 11.4814 17.6945 11.853 17.6945 12.3114V15.2163C17.6945 15.5601 17.4159 15.8388 17.0721 15.8388C16.7283 15.8388 16.4496 15.5601 16.4496 15.2163V12.7264H7.31991Z'
      />
      <path
        id='Vector 14 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.8847 8.36914C12.2285 8.36914 12.5072 8.64783 12.5072 8.99162L12.5072 12.104C12.5072 12.4478 12.2285 12.7265 11.8847 12.7265C11.5409 12.7265 11.2622 12.4478 11.2622 12.104L11.2622 8.99162C11.2622 8.64783 11.5409 8.36914 11.8847 8.36914Z'
      />
    </SvgIcon>
  )
}

export default HierarchyShowIcon
